import React, { useState, useRef, useEffect, useContext } from 'react'
import { AuthContext } from './../AuthContext'
import { Button, CloseButton } from 'react-bootstrap'
import axios from 'axios'

// import metabolicPlanData from '../../data/metabolicPlanData.json'
import { SearchOutlined } from '@ant-design/icons'

import { Input, Space, Table } from 'antd'
import Highlighter from 'react-highlight-words'
import { useMediaQuery } from 'react-responsive'

const MetabolicPlanTable = ({
  currentPatient,
  setCurrentPatient,
  caseModalShow,
  setCaseModalShow,
  setBasicInfoModalShow,
}) => {
  const isTablet = useMediaQuery({ maxWidth: 1224 })
  const [searchText, setSearchText] = useState('')
  const [searchedColumn, setSearchedColumn] = useState('')
  const searchInput = useRef(null)

  const [filteredInfo, setFilteredInfo] = useState({})
  const [sortedInfo, setSortedInfo] = useState({})
  const [selectedRowKey, setSelectedRowKey] = useState(null)
  const [metabolicPlanData, setMetabolicPlanData] = useState([])

  const [currentSearchName, setCurrentSearchName] = useState('')
  const [currentSearchbirthday, setCurrentSearchbirthday] = useState('')
  const [currentSearchId, setCurrentSearchId] = useState('')
  const [key, setKey] = useState(0)

  const {
    baseUrl,
    sendDiscordNotification,
    currentUser,
    setIsLoading,
    extendCookie,
  } = useContext(AuthContext)
  const getPatients = '/api/crm/project/getPatients'

  useEffect(() => {
    if (currentUser && currentUser.session) {
      let loadingTimer

      loadingTimer = setTimeout(() => {
        setIsLoading(true)
      }, 500)

      axios
        .post(
          baseUrl + getPatients,
          { project_id: 'P0001' },
          {
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
              Accept: '*/*',
              session: currentUser.session,
            },
          }
        )
        .then((res) => {
          console.log('getPatients', res.data.data)
          if (res.data.data) {
            extendCookie()
            setMetabolicPlanData(
              res.data.data.sort((a, b) =>
                a.next_appointment_time.localeCompare(b.next_appointment_time)
              )
            )
          }
        })
        .catch((e) => {
          console.log('GetPatients error', e)
          sendDiscordNotification(`GetPatients Error \n Error: ${e} `)
          alert('伺服器忙線中，請稍後再試')
        })
        .finally(() => {
          setIsLoading(false)
          clearTimeout(loadingTimer)
        })
    }
  }, [currentUser, caseModalShow])

  const initData = (metabolicPlanData) => {
    const data = []

    const filterId = metabolicPlanData.map((v, i) => {
      if (v.id_number) {
        let idStr = v.id_number
        let result = idStr.slice(0, 4) + '***' + idStr.slice(7)

        return result
      }
    })
    // const filterbirthday = metabolicPlanData.map((v, i) => {
    //   let birthdayArr = v.birthday.split('.')
    //   let birthdayNum = 0
    //   for (let i = 0; i < birthdayArr.length; i++) {
    //     birthdayNum = birthdayNum + birthdayArr[i]
    //   }
    //   return birthdayNum
    // })
    // const filterReturnDate = metabolicPlanData.map((v, i) => {
    //   // TODO之後if可拿掉
    //   if (v.next_appointment_time) {
    //     let returnDateArr = v.next_appointment_time?.split('/')
    //     let returnDateNum = 0

    //     for (let i = 0; i < returnDateArr.length; i++) {
    //       returnDateNum = returnDateNum + returnDateArr[i]
    //     }
    //     return returnDateNum
    //   }
    // })

    for (let i = 0; i < metabolicPlanData.length; i++) {
      data.push({
        ...metabolicPlanData[i],
        // filterbirthday: filterbirthday[i],
        filterId: filterId[i],
        // filterReturnDate: filterReturnDate[i],
      })
    }
    // 排序逻辑，处理已结案的数据
    const handleSorter = (data) => {
      // 过滤掉status不为2或3的记录（即已结案）
      const filteredData = data
        .filter((item) => item.status !== 2 && item.status !== 3)
        .sort((a, b) =>
          a.next_appointment_time.localeCompare(b.next_appointment_time)
        ) // 可以根据你的需求更改排序字段

      // 将status为2或3的记录（已结案）放到末端
      const closedData = data.filter(
        (item) => item.status === 2 || item.status === 3
      )

      // 返回已排序的数据
      return [...filteredData, ...closedData]
    }

    // 处理后的数据返回
    return handleSorter(data)
  }
  const dataSource = initData(metabolicPlanData)
  console.log('initData(metabolicPlanData)', initData(metabolicPlanData))

  // const clearFilters = () => {
  //   setFilteredInfo({})
  //   clearFilters()
  // }
  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }

  const clearAll = () => {
    setSearchText('')
    setSearchedColumn('')
    setCurrentSearchName('')
    setCurrentSearchbirthday('')
    setCurrentSearchId('')

    setKey((prevKey) => prevKey + 1)
  }

  const handleChange = (pagination, filters, sorter) => {
    // console.log('Various parameters', pagination, filters, sorter)
    setFilteredInfo(filters)
    setSortedInfo(sorter)
  }

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => {
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }}
          onPressEnter={() => {
            handleSearch(selectedKeys, confirm, dataIndex)
            if (dataIndex === 'name') {
              setCurrentSearchName(selectedKeys[0])
            } else if (dataIndex === 'birthday') {
              setCurrentSearchbirthday(selectedKeys[0])
            } else if (dataIndex === 'id_number') {
              setCurrentSearchId(selectedKeys[0])
            }
          }}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            id={`search-${dataIndex}`}
            variant="primary"
            onClick={() => {
              handleSearch(selectedKeys, confirm, dataIndex)
              if (dataIndex === 'name') {
                setCurrentSearchName(selectedKeys[0])
              } else if (dataIndex === 'birthday') {
                setCurrentSearchbirthday(selectedKeys[0])
              } else if (dataIndex === 'id_number') {
                setCurrentSearchId(selectedKeys[0])
              }
            }}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            id={`reset-${dataIndex}`}
            variant="outline-primary"
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>

          <CloseButton
            type="link"
            size="small"
            onClick={() => {
              close()
            }}
          >
            {/* close */}
          </CloseButton>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#67c7aa' : undefined,
          width: '100px',
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100)
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  })

  // const rowSelection = {
  //   // renderCell: (checked, record, index, originNode) => {
  //   //   console.log('checked', checked, record, index, originNode)
  //   // },
  //   // onChange: (selectedRowKeys, selectedRows) => {
  //   //   console.log(
  //   //     `selectedRowKeys: ${selectedRowKeys}`,
  //   //     'selectedRows: ',
  //   //     selectedRows
  //   //   )
  //   // },
  //   // getCheckboxProps: (record) => ({
  //   //   disabled: record.name === 'Disabled User',
  //   //   // Column configuration not to be checked
  //   //   name: record.name,
  //   // }),
  //   // onSelect: (record, selected, selectedRows, nativeEvent) => {
  //   //   console.log(
  //   //     'record', // {id: 'G106234567', name: '張家豪', birthday: '110.10.16'}
  //   //     record,
  //   //     'selected', // true
  //   //     selected,
  //   //     'selectedRows',
  //   //     /*[
  //   //       {
  //   //           "id": "G106234567",
  //   //           "name": "張家豪",
  //   //           "birthday": "110.10.16"
  //   //       }
  //   //   ]*/
  //   //     selectedRows,
  //   //     'nativeEvent',
  //   //     nativeEvent
  //   //   )
  //   // },
  // }

  const columns = [
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      width: '15%',
      ...getColumnSearchProps('name'),
      // sorter: (a, b) => nameSort(a, b),
    },
    {
      title: '生日',
      dataIndex: 'birthday',
      key: 'birthday',
      width: '20%',
      ...getColumnSearchProps('birthday'),
      // sorter: (a, b) => a.filterbirthday - b.filterbirthday,
      // ellipsis: true,
    },
    {
      title: isTablet ? 'ID' : '身分證字號',
      dataIndex: 'filterId',
      key: 'id_number',
      ...getColumnSearchProps('id_number'),
    },
    {
      title: isTablet ? '結案' : '結案狀態',
      dataIndex: 'status',
      key: 'status',
      width: '15%',
      ellipsis: true,
      render: (status) => {
        return status === 3 || status === 2 ? (
          <div className="caseClosed">已結案</div>
        ) : (
          <div className="caseUnClosed">未結案</div>
        )
      },
      filters: [
        {
          text: '已結案',
          value: 3,
        },
        {
          text: '未結案',
          value: -1,
        },
      ],
      onFilter: (value, record) => {
        if (value === -1) {
          return record.status !== 3 && record.status !== 2
        } else {
          return record.status === 3 || record.status === 2
        }
      },
    },
    {
      title: '回診日期',
      dataIndex: 'next_appointment_time',
      key: 'next_appointment_time',
      // ellipsis: true,
      sorter: (a, b) => {
        return a.status === 3 || a.status === 2
          ? ''
          : b.next_appointment_time.localeCompare(a.next_appointment_time)
      },

      render: (text, record) => {
        return record.status === 3 || record.status === 2 ? (
          <div className="caseClosed">已結案</div>
        ) : (
          <div>{text}</div>
        )
      },
    },
  ]
  return (
    <>
      {/* <Button onClick={setAgeSort}>Sort age</Button> */}
      {/* <Button onClick={clearFilters}>Clear filters</Button>*/}
      <div className="d-flex justify-content-center align-items-center mt-3">
        <div>
          <Button onClick={() => setCaseModalShow(true)}>新增個案</Button>
        </div>
        <div className="ms-3 d-flex justify-content-between w-75 align-items-center">
          <div className="searched">
            {currentSearchName || currentSearchbirthday || currentSearchId
              ? `已搜尋: ${currentSearchName && currentSearchName + ','}
            ${currentSearchbirthday && currentSearchbirthday + ','} ${currentSearchId}`
              : ''}
          </div>
          {currentSearchName || currentSearchbirthday || currentSearchId ? (
            <Button onClick={clearAll}>全部清除</Button>
          ) : (
            ''
          )}
        </div>
      </div>

      <Table
        className="mt-4 m-3"
        dataSource={dataSource}
        columns={columns}
        onChange={handleChange}
        onRow={(record, rowIndex) => {
          return {
            onClick: () => {
              setCurrentPatient(record)
              setSelectedRowKey(rowIndex)
              setBasicInfoModalShow(true)
            },
          }
        }}
        rowClassName={(record, rowIndex) => {
          return currentPatient === record ? 'selected' : ''
        }}
        rowKey={(record) => record.patient_id}
        key={key}
        // rowSelection={{
        //   type: 'radio',
        //   ...rowSelection,
        // }}
        pagination={{
          position: ['bottomCenter'],
          showSizeChanger: false,
        }}
      />
    </>
  )
}

export default MetabolicPlanTable
